import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import ImageSlider from '../../components/ImageSlider';
import imgLogo22 from '../../assets/img/logo2/logologo2.png';

import mem1 from '../../assets/img/mem-example1.png';
import mem2 from '../../assets/img/mem-example2.png';
import mem4 from '../../assets/img/mem-example4.png';
import mem8 from '../../assets/img/mem-example8.png';
import mem9 from '../../assets/img/mem-example9.png';
import SearchForm from '../../components/search';
import AccordionBlock from '../../components/AccordionBlock';
import { MainSection, MainSectionContent, MainTitle, MainDescription, MainDescriptionSmall, MainBtn, SearchSection, SearchTextContent, SearchHeader, SearchText, SearchIcons, SearchIconItem, PageDemo, PageDemoContainer, PhotoContainer, PageDemoTitle, PageDemoYears, PageDemoText, PageDemoBtn, DesignSection, DesignTitle, DesignDescription, DesignImages, StoreSection, StoreContainer, StoreTitle, StoreDescription, StoreIcons, StoreIconsItem, StoreIconsImageContainer, StoreIconsItemContent, StoreIconsItemHeader, StoreIconsItemText, TreeSection, TreeTitle, TreeDescription, TreeBtn, FAQSection, FAQTitle, FAQContainer, ActionSection, ActionTitle, ActionText, ActionBtn } from './styles';
import {useDispatch} from "react-redux";
import {setLoginOpen} from "../../store/appSlice";
import client, {API_HOST, UI_HOST, userSession} from "../../services/auth/ApiService/client";
import {IAnketa, initialState} from "../ChangePage/ChangePage";
import axios from "axios";
import { CSSTransition } from "react-transition-group";
import {Container} from "@mui/material";

const qrImages = [
  mem1,
  mem2,
  mem4,
  mem9,
  mem8,
]

const HomePage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [anketa, setAnketa] = React.useState<IAnketa>(initialState)
  const [anketas, setAnketas] = useState<IAnketa[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [inProp, setInProp] = useState(true);

  useEffect(() => {
    axios.get(`${API_HOST}/anketas?random=1&limit=10&page=0`).then((response) => {
      const data = response.data as IAnketa[];
      if (data[0]) {
        setAnketa(data[0])
        setAnketas(data)
      }
    })
  }, []);

  useEffect(() => {
    if (anketas.length === 0) return;

    const interval = setInterval(() => {
      setInProp(false); // Начинаем исчезновение
      setTimeout(() => {
        setCurrentIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % anketas.length;
          setAnketa(anketas[nextIndex]);
          setInProp(true); // Включаем анимацию появления
          return nextIndex;
        });
      }, 500); // Должно совпадать с `exit`-анимацией
    }, 8000);

    return () => clearInterval(interval);
  }, [anketas]);
  return (
    <>
      <MainSection>
        <Container style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          <MainSectionContent>
            <MainTitle>
              <img src={imgLogo22} />
              <span><b>Предтечи</b></span>
            </MainTitle>
            <MainDescription>
              Сохраните их историю <br />
              <span>Не только <b>имена</b></span>
              <MainDescriptionSmall>
                Перейдя по QR коду вы можете снова увидеть и услышать близкого человека
              </MainDescriptionSmall>
              <MainBtn onClick={(e) => {
                if (!userSession.getSession()) {
                  dispatch(setLoginOpen(true))
                } else {
                  navigate('/order')
                }
              }}>Сохранить</MainBtn>
            </MainDescription>
          </MainSectionContent>
        </Container>
      </MainSection>
      <Container style={{marginTop: '40px'}}>
        <SearchSection>
          <SearchTextContent>
            <SearchHeader>
              Сохраните их наследие
              <span>с помощью уникальных интерактивных страниц</span>
              и табличек с вашим дизайном
            </SearchHeader>
            <SearchText>
              Данные будут храниться в течении многих лет с возможностью
              быстрого доступа через QR-код.
            </SearchText>

            <SearchForm />
            <SearchIcons> 
              <SearchIconItem>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M20 0C20.3594 0 20.7188 0.078125 21.0469 0.226562L35.7578 6.46875C37.4766 7.19531 38.7578 8.89062 38.75 10.9375C38.7109 18.6875 35.5234 32.8672 22.0625 39.3125C20.7578 39.9375 19.2422 39.9375 17.9375 39.3125C4.47657 32.8672 1.28907 18.6875 1.25001 10.9375C1.24219 8.89062 2.52344 7.19531 4.24219 6.46875L18.9609 0.226562C19.2813 0.078125 19.6406 0 20 0Z" fill="#244D76"/>
                </svg>
                <span>Защита данных</span>
              </SearchIconItem>
              <SearchIconItem>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="46" viewBox="0 0 40 46" fill="none">
                  <g clipPath="url(#clip0_97_4086)">
                  <path d="M40 7.14286V11.4286C40 15.375 31.0446 18.5714 20 18.5714C8.95536 18.5714 0 15.375 0 11.4286V7.14286C0 3.19643 8.95536 0 20 0C31.0446 0 40 3.19643 40 7.14286ZM35.1071 19.1696C36.9643 18.5089 38.6696 17.6607 40 16.6161V25.7143C40 29.6607 31.0446 32.8571 20 32.8571C8.95536 32.8571 0 29.6607 0 25.7143V16.6161C1.33036 17.6696 3.03571 18.5089 4.89286 19.1696C8.90179 20.5982 14.2411 21.4286 20 21.4286C25.7589 21.4286 31.0982 20.5982 35.1071 19.1696ZM0 30.9018C1.33036 31.9554 3.03571 32.7946 4.89286 33.4554C8.90179 34.8839 14.2411 35.7143 20 35.7143C25.7589 35.7143 31.0982 34.8839 35.1071 33.4554C36.9643 32.7946 38.6696 31.9464 40 30.9018V38.5714C40 42.5179 31.0446 45.7143 20 45.7143C8.95536 45.7143 0 42.5179 0 38.5714V30.9018Z" fill="#244D76"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_97_4086">
                    <rect width="40" height="45.7143" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
                <span>Гарантия хранения  информации на протяжении 60 лет</span>
              </SearchIconItem>
              <SearchIconItem>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="46" viewBox="0 0 40 46" fill="none">
                  <path d="M0 7.14283C0 4.77676 1.91964 2.85712 4.28571 2.85712H12.8571C15.2232 2.85712 17.1429 4.77676 17.1429 7.14283V15.7143C17.1429 18.0803 15.2232 20 12.8571 20H4.28571C1.91964 20 0 18.0803 0 15.7143V7.14283ZM5.71429 8.5714V14.2857H11.4286V8.5714H5.71429ZM0 30C0 27.6339 1.91964 25.7143 4.28571 25.7143H12.8571C15.2232 25.7143 17.1429 27.6339 17.1429 30V38.5714C17.1429 40.9375 15.2232 42.8571 12.8571 42.8571H4.28571C1.91964 42.8571 0 40.9375 0 38.5714V30ZM5.71429 31.4285V37.1428H11.4286V31.4285H5.71429ZM27.1429 2.85712H35.7143C38.0804 2.85712 40 4.77676 40 7.14283V15.7143C40 18.0803 38.0804 20 35.7143 20H27.1429C24.7768 20 22.8571 18.0803 22.8571 15.7143V7.14283C22.8571 4.77676 24.7768 2.85712 27.1429 2.85712ZM34.2857 8.5714H28.5714V14.2857H34.2857V8.5714ZM22.8571 27.1428C22.8571 26.3571 23.5 25.7143 24.2857 25.7143H30C30.7857 25.7143 31.4286 26.3571 31.4286 27.1428C31.4286 27.9285 32.0714 28.5714 32.8571 28.5714H35.7143C36.5 28.5714 37.1429 27.9285 37.1429 27.1428C37.1429 26.3571 37.7857 25.7143 38.5714 25.7143C39.3571 25.7143 40 26.3571 40 27.1428V35.7143C40 36.5 39.3571 37.1428 38.5714 37.1428H32.8571C32.0714 37.1428 31.4286 36.5 31.4286 35.7143C31.4286 34.9285 30.7857 34.2857 30 34.2857C29.2143 34.2857 28.5714 34.9285 28.5714 35.7143V41.4285C28.5714 42.2143 27.9286 42.8571 27.1429 42.8571H24.2857C23.5 42.8571 22.8571 42.2143 22.8571 41.4285V27.1428ZM32.8571 42.8571C32.4783 42.8571 32.1149 42.7066 31.847 42.4387C31.5791 42.1708 31.4286 41.8074 31.4286 41.4285C31.4286 41.0497 31.5791 40.6863 31.847 40.4184C32.1149 40.1505 32.4783 40 32.8571 40C33.236 40 33.5994 40.1505 33.8673 40.4184C34.1352 40.6863 34.2857 41.0497 34.2857 41.4285C34.2857 41.8074 34.1352 42.1708 33.8673 42.4387C33.5994 42.7066 33.236 42.8571 32.8571 42.8571ZM38.5714 42.8571C38.1926 42.8571 37.8292 42.7066 37.5613 42.4387C37.2934 42.1708 37.1429 41.8074 37.1429 41.4285C37.1429 41.0497 37.2934 40.6863 37.5613 40.4184C37.8292 40.1505 38.1926 40 38.5714 40C38.9503 40 39.3137 40.1505 39.5816 40.4184C39.8495 40.6863 40 41.0497 40 41.4285C40 41.8074 39.8495 42.1708 39.5816 42.4387C39.3137 42.7066 38.9503 42.8571 38.5714 42.8571Z" fill="#244D76"/>
                </svg>
                <span>Уникальный дизайн каждой таблички</span>
              </SearchIconItem>
            </SearchIcons>
            
          </SearchTextContent>
          {anketa.name && (<CSSTransition in={inProp} timeout={500} classNames="fade" unmountOnExit>
            <PageDemo>
              <PageDemoContainer>
                <PhotoContainer><img src={anketa?.photo?.src} /></PhotoContainer>
                <PageDemoTitle>{anketa?.name}</PageDemoTitle>
                <PageDemoYears>{anketa.dateBorn} — {anketa.dateEnd}</PageDemoYears>
                <PageDemoText>{anketa.quote}</PageDemoText>
                <PageDemoBtn to={`${UI_HOST}/${anketa?.isSolder ? 'solder' : 'anketa'}/${anketa?.id}`}>Смотреть страницу  &gt;</PageDemoBtn>
              </PageDemoContainer>
            </PageDemo>
          </CSSTransition>)}
        </SearchSection>
      </Container>
      <DesignSection>
        <DesignTitle>Уникальный дизайн</DesignTitle>
        <DesignDescription>
          Благодаря нашему редактору вы сможете создать свой дизайн <br /> мемориальной таблички
        </DesignDescription>
        <DesignImages sx={ {marginRight: '-10px'} }>
          <ImageSlider images={qrImages} />
        </DesignImages>
      </DesignSection>

      <StoreSection>
        <StoreContainer>
          <StoreTitle>
            Что можно хранить на странице?
          </StoreTitle>
          <StoreDescription>
            Данные будут храниться в течении многих лет с возможностью
            <span>быстрого доступа через QR-код. </span>
          </StoreDescription>
          <StoreIcons>
            <StoreIconsItem>
              <StoreIconsImageContainer>
                <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.4609 34.9999V30.1952L12.0234 29.4452V7.24988H6.74996L6.53902 10.9296H0.328083V0.874878H32.039V10.9296H25.7578L25.5703 7.24988H20.25V29.4452L23.8125 30.1952V34.9999H8.4609Z" fill="#244D76"/>
                </svg>
              </StoreIconsImageContainer>
              <StoreIconsItemContent>
                <StoreIconsItemHeader>
                  ТЕКСТ
                </StoreIconsItemHeader>
                <StoreIconsItemText>
                  Краткая текстовая информация и этапы биографии, истории из жизни, эпитафия
                </StoreIconsItemText>
              </StoreIconsItemContent>
            </StoreIconsItem>
            <StoreIconsItem>
              <StoreIconsImageContainer>
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="40" viewBox="0 0 50 40" fill="none">
                  <path d="M41.6875 2.53912C46.7578 6.66412 50 12.9532 50 20.0001C50 27.0469 46.7578 33.3438 41.6875 37.461C40.8828 38.1172 39.7031 37.9922 39.0469 37.1876C38.3906 36.3829 38.5156 35.2032 39.3203 34.5469C43.5547 31.1094 46.25 25.8751 46.25 20.0001C46.25 14.1251 43.5547 8.89068 39.3203 5.44537C38.5156 4.78912 38.3984 3.60943 39.0469 2.80474C39.6953 2.00006 40.8828 1.88287 41.6875 2.53131V2.53912ZM36.9609 8.35943C40.3359 11.1094 42.5 15.3047 42.5 20.0001C42.5 24.6954 40.3359 28.8907 36.9609 31.6407C36.1562 32.2969 34.9766 32.1719 34.3203 31.3672C33.6641 30.5626 33.7891 29.3829 34.5938 28.7266C37.1328 26.6641 38.75 23.5235 38.75 20.0001C38.75 16.4766 37.1328 13.336 34.5938 11.2657C33.7891 10.6094 33.6719 9.42974 34.3203 8.62506C34.9688 7.82037 36.1562 7.70318 36.9609 8.35162V8.35943ZM32.2344 14.1797C33.9141 15.5547 35 17.6485 35 20.0001C35 22.3516 33.9141 24.4454 32.2344 25.8204C31.4297 26.4766 30.25 26.3516 29.5938 25.5469C28.9375 24.7422 29.0625 23.5626 29.8672 22.9063C30.7109 22.2188 31.25 21.1719 31.25 20.0001C31.25 18.8282 30.7109 17.7813 29.8672 17.086C29.0625 16.4297 28.9453 15.2501 29.5938 14.4454C30.2422 13.6407 31.4297 13.5235 32.2344 14.1719V14.1797ZM23.5234 2.7188C24.4219 3.12505 25 4.01568 25 5.00006V35.0001C25 35.9844 24.4219 36.8751 23.5234 37.2813C22.625 37.6876 21.5703 37.5235 20.8359 36.8672L10.2969 27.5001H5C2.24219 27.5001 0 25.2579 0 22.5001V17.5001C0 14.7422 2.24219 12.5001 5 12.5001H10.2969L20.8359 3.13287C21.5703 2.47662 22.625 2.32037 23.5234 2.7188Z" fill="#244D76"/>
                </svg>
              </StoreIconsImageContainer>
              <StoreIconsItemContent>
                <StoreIconsItemHeader>
                  АУДИОЗАПИСИ
                </StoreIconsItemHeader>
                <StoreIconsItemText>
                  Записанный голос, аудиообращения, песни и мероприятия
                </StoreIconsItemText>
              </StoreIconsItemContent>
            </StoreIconsItem>
            <StoreIconsItem>
              <StoreIconsImageContainer>
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="45" viewBox="0 0 50 45" fill="none">
                  <path d="M33.3333 41.3282L16.6667 36.5626V3.11637L33.3333 7.882V41.3282ZM36.1111 41.224V7.67367L47.1441 3.25526C48.5156 2.70839 50 3.71533 50 5.19103V34.2535C50 35.1042 49.4792 35.8681 48.6892 36.1893L36.1111 41.2153V41.224ZM1.31076 8.25526L13.8889 3.22922V36.7709L2.8559 41.1893C1.48438 41.7362 0 40.7292 0 39.2535V10.191C0 9.34033 0.520833 8.57644 1.31076 8.25526Z" fill="#244D76"/>
                </svg>
              </StoreIconsImageContainer>
              <StoreIconsItemContent>
                <StoreIconsItemHeader>
                  КАРТЫ
                </StoreIconsItemHeader>
                <StoreIconsItemText>
                  Указывайте место захоронения для 
                  простого доступа и возможностью
                  создать маршрут
                </StoreIconsItemText>
              </StoreIconsItemContent>
            </StoreIconsItem>
            <StoreIconsItem>
              <StoreIconsImageContainer>
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="45" viewBox="0 0 50 45" fill="none">
                  <path d="M47.7131 10.7711C47.1679 8.71813 45.5615 7.10129 43.5218 6.55259C39.8248 5.55554 25 5.55554 25 5.55554C25 5.55554 10.1754 5.55554 6.47823 6.55259C4.43856 7.10138 2.83213 8.71813 2.28691 10.7711C1.29628 14.4922 1.29628 22.2559 1.29628 22.2559C1.29628 22.2559 1.29628 30.0196 2.28691 33.7407C2.83213 35.7936 4.43856 37.3431 6.47823 37.8918C10.1754 38.8889 25 38.8889 25 38.8889C25 38.8889 39.8247 38.8889 43.5218 37.8918C45.5615 37.3431 47.1679 35.7936 47.7131 33.7407C48.7038 30.0196 48.7038 22.2559 48.7038 22.2559C48.7038 22.2559 48.7038 14.4922 47.7131 10.7711ZM20.1515 29.3048V15.207L32.542 22.2561L20.1515 29.3048Z" fill="#244D76"/>
                </svg>
              </StoreIconsImageContainer>
              <StoreIconsItemContent>
                <StoreIconsItemHeader>
                  ВИДЕО
                </StoreIconsItemHeader>
                <StoreIconsItemText>
                  Youtube, VK, Vimio и другие видео сервисы или можно загрузить свое видео напрямую
                </StoreIconsItemText>
              </StoreIconsItemContent>
            </StoreIconsItem>
            <StoreIconsItem>
              <StoreIconsImageContainer>
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="40" viewBox="0 0 50 40" fill="none">
                  <path d="M45.2969 20.9141C49.7109 16.5 49.7109 9.3516 45.2969 4.93754C41.3906 1.03129 35.2344 0.523476 30.7422 3.73441L30.6172 3.82035C29.4922 4.62504 29.2344 6.18754 30.0391 7.30473C30.8438 8.42191 32.4062 8.68754 33.5234 7.88285L33.6484 7.79691C36.1562 6.00785 39.5859 6.2891 41.7578 8.46879C44.2188 10.9297 44.2188 14.9141 41.7578 17.375L32.9922 26.1563C30.5312 28.6172 26.5469 28.6172 24.0859 26.1563C21.9062 23.9766 21.625 20.5469 23.4141 18.0469L23.5 17.9219C24.3047 16.7969 24.0391 15.2344 22.9219 14.4375C21.8047 13.6407 20.2344 13.8985 19.4375 15.0157L19.3516 15.1407C16.1328 19.625 16.6406 25.7813 20.5469 29.6875C24.9609 34.1016 32.1094 34.1016 36.5234 29.6875L45.2969 20.9141ZM4.70312 19.086C0.289062 23.5 0.289062 30.6485 4.70312 35.0625C8.60938 38.9688 14.7656 39.4766 19.2578 36.2657L19.3828 36.1797C20.5078 35.375 20.7656 33.8125 19.9609 32.6954C19.1562 31.5782 17.5938 31.3125 16.4766 32.1172L16.3516 32.2032C13.8438 33.9922 10.4141 33.711 8.24219 31.5313C5.78125 29.0625 5.78125 25.0782 8.24219 22.6172L17.0078 13.8438C19.4688 11.3829 23.4531 11.3829 25.9141 13.8438C28.0938 16.0235 28.375 19.4532 26.5859 21.961L26.5 22.086C25.6953 23.211 25.9609 24.7735 27.0781 25.5704C28.1953 26.3672 29.7656 26.1094 30.5625 24.9922L30.6484 24.8672C33.8672 20.375 33.3594 14.2188 29.4531 10.3125C25.0391 5.89848 17.8906 5.89848 13.4766 10.3125L4.70312 19.086Z" fill="#244D76"/>
                </svg>
              </StoreIconsImageContainer>
              <StoreIconsItemContent>
                <StoreIconsItemHeader>
                  ССЫЛКИ
                </StoreIconsItemHeader>
                <StoreIconsItemText>
                  Ссылки на другие страницы, социальные сети и др. сервисы
                </StoreIconsItemText>
              </StoreIconsItemContent>
            </StoreIconsItem>
            <StoreIconsItem>
              <StoreIconsImageContainer>
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
                  <path d="M0 7.6875C0 4.86074 2.29824 2.5625 5.125 2.5625H35.875C38.7018 2.5625 41 4.86074 41 7.6875V33.3125C41 36.1393 38.7018 38.4375 35.875 38.4375H5.125C2.29824 38.4375 0 36.1393 0 33.3125V7.6875ZM25.9293 16.2158C25.5689 15.6873 24.9764 15.375 24.3438 15.375C23.7111 15.375 23.1105 15.6873 22.7582 16.2158L15.7914 26.4338L13.6693 23.7832C13.301 23.3268 12.7484 23.0625 12.1719 23.0625C11.5953 23.0625 11.0348 23.3268 10.6744 23.7832L5.54941 30.1895C5.08496 30.766 4.99688 31.5588 5.31719 32.2234C5.6375 32.8881 6.31016 33.3125 7.04688 33.3125H14.7344H17.2969H33.9531C34.6658 33.3125 35.3225 32.9201 35.6508 32.2875C35.9791 31.6549 35.9391 30.8941 35.5387 30.3096L25.9293 16.2158ZM8.96875 15.375C9.98818 15.375 10.9658 14.97 11.6867 14.2492C12.4075 13.5283 12.8125 12.5507 12.8125 11.5312C12.8125 10.5118 12.4075 9.53415 11.6867 8.81331C10.9658 8.09247 9.98818 7.6875 8.96875 7.6875C7.94932 7.6875 6.97165 8.09247 6.25081 8.81331C5.52997 9.53415 5.125 10.5118 5.125 11.5312C5.125 12.5507 5.52997 13.5283 6.25081 14.2492C6.97165 14.97 7.94932 15.375 8.96875 15.375Z" fill="#244D76"/>
                </svg>
              </StoreIconsImageContainer>
              <StoreIconsItemContent>
                <StoreIconsItemHeader>
                  ФОТОГРАФИИ
                </StoreIconsItemHeader>
                <StoreIconsItemText>
                  Загружайте любое количество фотографий к любым событиям. Создавайте галереи
                </StoreIconsItemText>
              </StoreIconsItemContent>
            </StoreIconsItem>
          </StoreIcons>
        </StoreContainer>
      </StoreSection>

      <TreeSection>
        <TreeTitle>
          СЕМЕЙНОЕ ДРЕВО
        </TreeTitle>
        <TreeDescription>
          Формируйте родственные связи через семейное древо
        </TreeDescription>
        <TreeBtn variant="contained" onClick={(e) => {
          if (!userSession.getSession()) {
            dispatch(setLoginOpen(true))
          } else {
            navigate('/order')
          }
        }}>
          Заполнить анкету
        </TreeBtn>
      </TreeSection>

      <FAQSection>
        <Container>
          <FAQTitle>
            Часто задаваемые вопросы
          </FAQTitle>
          <FAQContainer>
            <AccordionBlock />
          </FAQContainer>
        </Container>
      </FAQSection>

      <ActionSection>
        <ActionTitle>ПОДЕЛИТЕСЬ МОМЕНТОМ ПАМЯТИ БЛИЗКОГО ЧЕЛОВЕКА</ActionTitle>
        <ActionText>С нашими табличками памяти</ActionText>
        <ActionBtn onClick={(e) => {
          if (!userSession.getSession()) {
            dispatch(setLoginOpen(true))
          } else {
            navigate('/order')
          }
        }} variant="contained">Заполнить анкету</ActionBtn>
      </ActionSection>
    </>
  );
}

export default HomePage;